// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.availability-day[data-v-ac7f4eb9] {
  padding: 0 10px 0 10px;
  position: absolute;
}
.availability-slots[data-v-ac7f4eb9] {
  max-width: 332px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  white-space: nowrap;
}
.availability-slot[data-v-ac7f4eb9] {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.availability-slot-group[data-v-ac7f4eb9] {
  display: flex;
  flex-direction: column;
}
.time-zone[data-v-ac7f4eb9] {
  padding: 32px 12px 12px 0;
}
.week-day-container[data-v-ac7f4eb9] {
  box-sizing: border-box;
  margin-bottom: 32px;
  max-width: 500px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.button[data-v-ac7f4eb9] {
  align-self: flex-end;
}
.label-weekday[data-v-ac7f4eb9] {
  position: relative;
  display: flex;
  align-items: flex-start;
  min-width: 77px;
  width: 77px;
}
.label-weekday > span[data-v-ac7f4eb9] {
  height: 50px;
  display: flex;
  align-items: center;
}
.add-another[data-v-ac7f4eb9] {
  background-color: transparent;
  border: none;
  opacity: 0.5;
  display: inline-flex;
  padding: 0;
  margin: 0;
  margin-bottom: 3px;
}
.add-another[data-v-ac7f4eb9]:hover {
  opacity: 1;
}
.to-text[data-v-ac7f4eb9] {
  padding-right: 12px;
}
.time-zone-text[data-v-ac7f4eb9] {
  padding-left: 22px;
}
.empty-content[data-v-ac7f4eb9] {
  color: var(--color-text-lighter);
  display: inline-flex;
  align-items: center;
}
.start-date[data-v-ac7f4eb9] {
  padding-right: 12px;
}
.day-container[data-v-ac7f4eb9] {
  display: flex;
  max-width: 500px;
  width: 100%;
  gap: 24px;
  border-top: 1px solid var(--color-border);
  padding-top: calc(3 * var(--default-grid-baseline));
  margin-top: calc(2 * var(--default-grid-baseline));
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/calendar-availability-vue/dist/assets/index-Ds7BWaqb.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,yCAAyC;EACzC,mDAAmD;EACnD,kDAAkD;AACpD","sourcesContent":[".availability-day[data-v-ac7f4eb9] {\n  padding: 0 10px 0 10px;\n  position: absolute;\n}\n.availability-slots[data-v-ac7f4eb9] {\n  max-width: 332px;\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  white-space: nowrap;\n}\n.availability-slot[data-v-ac7f4eb9] {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.availability-slot-group[data-v-ac7f4eb9] {\n  display: flex;\n  flex-direction: column;\n}\n.time-zone[data-v-ac7f4eb9] {\n  padding: 32px 12px 12px 0;\n}\n.week-day-container[data-v-ac7f4eb9] {\n  box-sizing: border-box;\n  margin-bottom: 32px;\n  max-width: 500px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n.button[data-v-ac7f4eb9] {\n  align-self: flex-end;\n}\n.label-weekday[data-v-ac7f4eb9] {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  min-width: 77px;\n  width: 77px;\n}\n.label-weekday > span[data-v-ac7f4eb9] {\n  height: 50px;\n  display: flex;\n  align-items: center;\n}\n.add-another[data-v-ac7f4eb9] {\n  background-color: transparent;\n  border: none;\n  opacity: 0.5;\n  display: inline-flex;\n  padding: 0;\n  margin: 0;\n  margin-bottom: 3px;\n}\n.add-another[data-v-ac7f4eb9]:hover {\n  opacity: 1;\n}\n.to-text[data-v-ac7f4eb9] {\n  padding-right: 12px;\n}\n.time-zone-text[data-v-ac7f4eb9] {\n  padding-left: 22px;\n}\n.empty-content[data-v-ac7f4eb9] {\n  color: var(--color-text-lighter);\n  display: inline-flex;\n  align-items: center;\n}\n.start-date[data-v-ac7f4eb9] {\n  padding-right: 12px;\n}\n.day-container[data-v-ac7f4eb9] {\n  display: flex;\n  max-width: 500px;\n  width: 100%;\n  gap: 24px;\n  border-top: 1px solid var(--color-border);\n  padding-top: calc(3 * var(--default-grid-baseline));\n  margin-top: calc(2 * var(--default-grid-baseline));\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
